import React from 'react';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import Button from '@mui/joy/Button';

import Success from 'components/Success';

import { FHRequestType } from 'stores/fhrequest_store';
import useFHRequest from 'hooks/useFHRequest';
import useRoles from 'hooks/useRoles';
import useWorkKey from 'hooks/useWorkKey';

const RequestInfoEditStatus = ({ request }: { request: FHRequestType }) => {

    const workKey = useWorkKey();
    const { hasRole } = useRoles();
    const { supportCloseQuietly } = useFHRequest();
    const [saving, setSaving] = React.useState(false);

    async function doSave() {
        if(!workKey) {
            return;
        }
        setSaving(true);
        await supportCloseQuietly(workKey, request.uuid);
        setSaving(false);
        Success('Closed');
    }

    if(!workKey || !request) {
        return null;
    }
    if(!hasRole('support')) {
        return null;
    }

    if(request.status >= 20) {
        return (
            <Stack alignItems="center">
                <Typography
                    level="title-sm">
                    This request is closed
                </Typography>
            </Stack>

        );
    }

    return (
        <Stack
            my={2}
            spacing={2}
            alignItems="center"
        >
            <Typography
                level="title-sm">
                Close without notification
            </Typography>

            <Stack spacing={1} direction="row" alignItems="space-between">
                <Button
                    variant={saving ? 'outlined' : undefined}
                    size="sm"
                    loading={saving}
                    onClick={doSave}
                >Close Quietly</Button>
            </Stack>
        </Stack>
    );

}

export default RequestInfoEditStatus;
